/*
Force	
Displacement	
Great Possessing	
Great Invigorating	
Small Harvest	
Attending	
Great Accumulating	
Pervading

Treading	
Open	
Polarising	
Converting the Maiden	
Inner Truth	
Articulating	
Diminishing	
Nearing

Concording People	
Skinning	
Radiance	
Abounding	
Dwelling People	
Already Fording	
Adorning	
Intelligence Hidden

Innocence
Following
Gnawing Bite
Shake	
Augmenting	
Sprouting	
Swallowing	
Returning

Coupling	Great 
Exceeding	
Holding	Persevering	
Ground	
Welling	
Correcting	
Ascending

Arguing	
Confining	
Before Completion	
Deliverance	
Dispersing	
Gorge	
Enveloping	
Leading


Retiring	
Conjoining	
Sojourning	
Small Exceeding	
Infiltrating	
Limping	
Bound	
Humbling


Obstruction	
Clustering	
Prospering	
Providing-For	
Viewing	
GroupingStripping	
Field
*/

    const theHexagrams = {
        force: {
            name: 'force',
            upper: 'heaven',
            lower: 'heaven',
            hexagram: 'force',
        },
        displacement: {
            name: 'displacement',
            upper: 'heaven',
            lower: 'earth',
            hexagram: 'displacement',
        },
        greatPossessing: {
            name: 'greatPossessing',
            upper: 'heaven',
            lower: 'lake',
            hexagram: 'greatPossessing',
        },
        greatInvigorating: {
            name: 'greatInvigorating',
            upper: 'thunder',
            lower: 'heaven',
            hexagram: 'greatInvigorating',
        },
        smallHarvest: {
            name: 'smallHarvest',
            upper: 'wind',
            lower: 'heaven',
            hexagram: 'smallHarvest',
        },
        attending: {
            name: 'attending',
            upper: 'water',
            lower: 'heaven',
            hexagram: 'attending',
        },
        greatAccumulating: {
            name: 'greatAccumulating',
            upper: 'mountain',
            lower: 'heaven',
            hexagram: 'greatAccumulating',
        },
        pervading: {
            name: 'pervading',
            upper: 'earth',
            lower: 'heaven',
            hexagram: 'pervading',
        },
        treading: {
            name: 'treading',
            upper: 'heaven',
            lower: 'lake',
            hexagram: 'treading',
        },
        open: {
            name: 'open',
            upper: 'lake',
            lower: 'lake',
            hexagram: 'open',
        },
        polarising: {
            name: 'polarising',
            upper: 'flame',
            lower: 'lake',
            hexagram: 'polarising',
        },
        convertingTheMaiden: {
            name: 'convertingTheMaiden',
            upper: 'thunder',
            lower: 'lake',
            hexagram: 'convertingTheMaiden',
        },
        innerTruth: {
            name: 'innerTruth',
            upper: 'wind',
            lower: 'lake',
            hexagram: 'innerTruth',
        },
        articulating: {
            name: 'articulating',
            upper: 'water',
            lower: 'lake',
            hexagram: 'articulating',
        },
        diminishing: {
            name: 'diminishing',
            upper: 'mountain',
            lower: 'lake',
            hexagram: 'diminishing',
        },
        nearing: {
            name: 'nearing',
            upper: 'earth',
            lower: 'lake',
            hexagram: 'nearing',
        },
        concordingPeople: {
            name: 'concordingPeople',
            upper: 'heaven',
            lower: 'flame',
            hexagram: 'concordPeople',
        },
        skinning: {
            name: 'skinning',
            upper: 'lake',
            lower: 'flame',
            hexagram: 'skinning',
        },
        radiance: {
            name: 'radiance',
            upper: 'flame',
            lower: 'flame',
            hexagram: 'radiance',
        },
        abounding: {
            name: 'abounding',
            upper: 'thunder',
            lower: 'flame',
            hexagram: 'abounding',
        },
        dwellingPeople: {
            name: 'dwellingPeople',
            upper: 'wind',
            lower: 'flame',
            hexagram: 'dwellingPeople',
        },
        alreadyFording: {
            name: 'alreadyFording',
            upper: 'water',
            lower: 'flame',
            hexagram: 'alreadyFording',
        },
        adorning: {
            name: 'adorning',
            upper: 'mountain',
            lower: 'flame',
            hexagram: 'adorning',
        }, 
        intelligenceHidden: {
            name: 'intelligenceHidden',
            upper: 'earth',
            lower: 'flame',
            hexagram: 'intelligenceHidden',
        },
        innocence: {
            name: 'innocence',
            upper: 'heaven',
            lower: 'thunder',
            hexagram: 'innocence',
        },
        following: {
            name: 'following',
            upper: 'lake',
            lower: 'thunder',
            hexagram: 'following',
        },
        gnawingBite: {
            name: 'gnawingBite',
            upper: 'flame',
            lower: 'thunder',
            hexagram: 'gnawingBite',
        },
        shake: {
            name: 'shake',
            upper: 'thunder',
            lower: 'thunder',
            hexagram: 'shake',
        },
        augmenting: {
            name: 'augmenting',
            upper: 'wind',
            lower: 'thunder',
            hexagram: 'augmenting',
        },
        sprouting: {
            name: 'sprouting',
            upper: 'water',
            lower: 'thunder',
            hexagram: 'sprouting',
        },
        swallowing: {
            name: 'swallowing',
            upper: 'mountain',
            lower: 'thunder',
            hexagram: 'swallowing',
        },
        returning: {
            name: 'returning',
            upper: 'earth',
            lower: 'thunder',
            hexagram: 'returning',
        },
        coupling: {
            name: 'coupling',
            upper: 'earth',
            lower: 'wind',
            hexagram: 'coupling',
        },
        greatExceeding: {
            name: 'greatExceeding',
            upper: 'lake',
            lower: 'wind',
            hexagram: 'greatExceeding',
        },
        holding: {
            name: 'holding',
            upper: 'flame',
            lower: 'wind',
            hexagram: 'holding',
        },
        persevering: {
            name: 'persevering',
            upper: 'thunder',
            lower: 'wind',
            hexagram: 'persevering',
        },
        ground: {
            name: 'ground',
            upper: 'wind',
            lower: 'wind',
            hexagram: 'ground',
        },
        welling: {
            name: 'welling',
            upper: 'water',
            lower: 'wind',
            hexagram: 'welling',
        },
        correcting: {
            name: 'correcting',
            upper: 'mountain',
            lower: 'wind',
            hexagram: 'correcting',
        },
        ascending: {
            name: 'ascending',
            upper: 'earth',
            lower: 'wind',
            hexagram: 'ascending',
        },
        arguing: {
            name: 'arguing',
            upper: 'earth',
            lower: 'water',
            hexagram: 'arguing',
        },
        confining: {
            name: 'confining',
            upper: 'lake',
            lower: 'water',
            hexagram: 'confining',
        },
        beforeCompletion: {
            name: 'beforeCompletion',
            upper: 'flame',
            lower: 'water',
            hexagram: 'beforeCompletion',
        },
        deliverance: {
            name: 'deliverance',
            upper: 'thunder',
            lower: 'water',
            hexagram: 'deliverance',
        },
        dispersing: {
            name: 'dispersing',
            upper: 'wind',
            lower: 'water',
            hexagram: 'dispersing',
        },
        gorge: {
            name: 'gorge',
            upper: 'water',
            lower: 'water',
            hexagram: 'gorge',
        },
        enveloping: {
            name: 'enveloping',
            upper: 'mountain',
            lower: 'water',
            hexagram: 'enveloping',
        },
        leading: {
            name: 'leading',
            upper: 'earth',
            lower: 'water',
            hexagram: 'leading',
        },
        retiring: {
            name: 'retiring',
            upper: 'earth',
            lower: 'mountain',
            hexagram: 'retiring',
        },
        conjoining: {
            name: 'conjoining',
            upper: 'lake',
            lower: 'mountain',
            hexagram: 'conjoining',
        },
        sojourning: {
            name: 'sojourning',
            upper: 'flame',
            lower: 'mountain',
            hexagram: 'sojourning',
        },
        smallExceeding: {
            name: 'smallExceeding',
            upper: 'thunder',
            lower: 'mountain',
            hexagram: 'smallExceeding',
        },
        infiltrating: {
            name: 'infiltrating',
            upper: 'wind',
            lower: 'mountain',
            hexagram: 'infiltrating',
        },
        limping: {
            name: 'limping',
            upper: 'water',
            lower: 'mountain',
            hexagram: 'limping',
        },
        bound: {
            name: 'bound',
            upper: 'mountain',
            lower: 'mountain',
            hexagram: 'bound',
        },
        humbling: {
            name: 'humbling',
            upper: 'earth',
            lower: 'mountain',
            hexagram: 'humbling',
        },
        obstruction: {
            name: 'obstruction',
            upper: 'heaven',
            lower: 'earth',
            hexagram: 'obstruction',
        },
        clustering: {
            name: 'clustering',
            upper: 'lake',
            lower: 'earth',
            hexagram: 'clustering',
        },
        prospering: {
            name: 'prospering',
            upper: 'flame',
            lower: 'earth',
            hexagram: 'prospering',
        },
        providingFor: {
            name: 'providingFor',
            upper: 'thunder',
            lower: 'earth',
            hexagram: 'providingFor',
        },
        viewing: {
            name: 'viewing',
            upper: 'wind',
            lower: 'earth',
            hexagram: 'viewing',
        },
        grouping: {
            name: 'grouping',
            upper: 'water',
            lower: 'earth',
            hexagram: 'grouping',
        },
        stripping: {
            name: 'stripping',
            upper: 'mountain',
            lower: 'earth',
            hexagram: 'stripping',
        },
        field: {
            name: 'field',
            upper: 'earth',
            lower: 'earth',
            hexagram: 'field',
        }
    }

    const theHexagrams2 = {
        force: {
            name: 'force',
            upper: 'heaven',
            lower: 'heaven',
            hexagram: 'force',
            chinesseSign: '乾',
            unicode: 'U+4D32'
        },
        displacement: {
            name: 'displacement',
            upper: 'heaven',
            lower: 'earth',
            hexagram: 'displacement',
            chinesseSign: '坤',
            unicode: 'U+5DE7'
        },
        greatPossessing: {
            name: 'great Possessing',
            upper: 'heaven',
            lower: 'lake',
            hexagram: 'greatPossessing',
            chinesseSign: '泰',
            unicode: 'U+6CF0'
        },
        greatInvigorating: {
            name: 'great Invigorating',
            upper: 'thunder',
            lower: 'heaven',
            hexagram: 'greatInvigorating',
            chinesseSign: '否',
            unicode: 'U+5426'
        },
        smallHarvest: {
            name: 'smallHarvest',
            upper: 'wind',
            lower: 'heaven',
            hexagram: 'smallHarvest',
            chinesseSign: '小畜',
            unicode: 'U+5C3C'
        },
        attending: {
            name: 'attending',
            upper: 'water',
            lower: 'heaven',
            hexagram: 'attending',
            chinesseSign: '需',
            unicode: 'U+9702'
        },
        greatAccumulating: {
            name: 'greatAccumulating',
            upper: 'mountain',
            lower: 'heaven',
            hexagram: 'greatAccumulating',
            chinesseSign: '大壯',
            unicode: 'U+592F'
        },
        pervading: {
            name: 'pervading',
            upper: 'earth',
            lower: 'heaven',
            hexagram: 'pervading',
            chinesseSign: '晉',
            unicode: 'U+6649'
        },
        treading: {
            name: 'treading',
            upper: 'heaven',
            lower: 'lake',
            hexagram: 'treading',
            chinesseSign: '大過',
            unicode: 'U+592A'
        },
        open: {
            name: 'open',
            upper: 'lake',
            lower: 'lake',
            hexagram: 'open',
            chinesseSign: '頤',
            unicode: 'U+9814'
        },
        polarising: {
            name: 'polarising',
            upper: 'flame',
            lower: 'lake',
            hexagram: 'polarising',
            chinesseSign: '豫',
            unicode: 'U+8C6B'
        },
        convertingTheMaiden: {
            name: 'convertingTheMaiden',
            upper: 'thunder',
            lower: 'lake',
            hexagram: 'convertingTheMaiden',
            chinesseSign: '革',
            unicode: 'U+9769'
        },
        innerTruth: {
            name: 'innerTruth',
            upper: 'wind',
            lower: 'lake',
            hexagram: 'innerTruth',
            chinesseSign: '大畜',
            unicode: 'U+592C'
        },
        articulating: {
            name: 'articulating',
            upper: 'water',
            lower: 'lake',
            hexagram: 'articulating',
            chinesseSign: '頤',
            unicode: 'U+9814'
        },
        diminishing: {
            name: 'diminishing',
            upper: 'mountain',
            lower: 'lake',
            hexagram: 'diminishing',
            chinesseSign: '大過',
            unicode: 'U+592A'
        },
        nearing: {
            name: 'nearing',
            upper: 'earth',
            lower: 'lake',
            hexagram: 'nearing',
            chinesseSign: '坎',
            unicode: 'U+574E'
        },
        concordingPeople: {
            name: 'concordingPeople',
            upper: 'heaven',
            lower: 'flame',
            hexagram: 'concordPeople',
            chinesseSign: '蠱',
            unicode: 'U+882B'
        },
        skinning: {
            name: 'skinning',
            upper: 'lake',
            lower: 'flame',
            hexagram: 'skinning',
            chinesseSign: '臨',
            unicode: 'U+81E8'
        },
        radiance: {
            name: 'radiance',
            upper: 'flame',
            lower: 'flame',
            hexagram: 'radiance',
            chinesseSign: '明夷',
            unicode: 'U+6607'
        },
        abounding: {
            name: 'abounding',
            upper: 'thunder',
            lower: 'flame',
            hexagram: 'abounding',
            chinesseSign: '家人',
            unicode: 'U+5BB6'
        },
        dwellingPeople: {
            name: 'dwellingPeople',
            upper: 'wind',
            lower: 'flame',
            hexagram: 'dwellingPeople',
            chinesseSign: '睽',
            unicode: 'U+774D'
        },
        alreadyFording: {
            name: 'alreadyFording',
            upper: 'water',
            lower: 'flame',
            hexagram: 'alreadyFording',
            chinesseSign: '蹇',
            unicode: 'U+8E47'
        },
        adorning: {
            name: 'adorning',
            upper: 'mountain',
            lower: 'flame',
            hexagram: 'adorning',
            chinesseSign: '既濟',
            unicode: 'U+65E2'
        },
        intelligenceHidden: {
            name: 'intelligenceHidden',
            upper: 'earth',
            lower: 'flame',
            hexagram: 'intelligenceHidden',
            chinesseSign: '未濟',
            unicode: 'U+672A'
        },
        innocence: {
            name: 'innocence',
            upper: 'heaven',
            lower: 'thunder',
            hexagram: 'innocence',
            chinesseSign: '豐',
            unicode: 'U+8C50'
        },
        following: {
            name: 'following',
            upper: 'lake',
            lower: 'thunder',
            hexagram: 'following',
            chinesseSign: '旅',
            unicode: 'U+65C5'
        },
        gnawingBite: {
            name: 'gnawingBite',
            upper: 'flame',
            lower: 'thunder',
            hexagram: 'gnawingBite',
            chinesseSign: '巽',
            unicode: 'U+5DFD'
        },
        shake: {
            name: 'shake',
            upper: 'thunder',
            lower: 'thunder',
            hexagram: 'shake',
            chinesseSign: '震',
            unicode: 'U+9707'
        },
        augmenting: {
            name: 'augmenting',
            upper: 'wind',
            lower: 'thunder',
            hexagram: 'augmenting',
            chinesseSign: '恒',
            unicode: 'U+6042'
        },
        sprouting: {
            name: 'sprouting',
            upper: 'water',
            lower: 'thunder',
            hexagram: 'sprouting',
            chinesseSign: '艮',
            unicode: 'U+826E'
        },
        swallowing: {
            name: 'swallowing',
            upper: 'mountain',
            lower: 'thunder',
            hexagram: 'swallowing',
            chinesseSign: '渙',
            unicode: 'U+6E1A'
        },
        returning: {
            name: 'returning',
            upper: 'earth',
            lower: 'thunder',
            hexagram: 'returning',
            chinesseSign: '風',
            unicode: 'U+98A8'
        },
        coupling: {
            name: 'coupling',
            upper: 'earth',
            lower: 'wind',
            hexagram: 'coupling',
            chinesseSign: '小畜',
            unicode: 'U+5C3C'
        },
        greatExceeding: {
            name: 'greatExceeding',
            upper: 'lake',
            lower: 'wind',
            hexagram: 'greatExceeding',
            chinesseSign: '大畜',
            unicode: 'U+592C'
        },
        holding: {
            name: 'holding',
            upper: 'flame',
            lower: 'wind',
            hexagram: 'holding',
            chinesseSign: '頤',
            unicode: 'U+9814'
        },
        persevering: {
            name: 'persevering',
            upper: 'thunder',
            lower: 'wind',
            hexagram: 'persevering',
            chinesseSign: '大過',
            unicode: 'U+592A'
        },
        ground: {
            name: 'ground',
            upper: 'wind',
            lower: 'wind',
            hexagram: 'ground',
            chinesseSign: '坎',
            unicode: 'U+574E'
        },
        welling: {
            name: 'welling',
            upper: 'water',
            lower: 'wind',
            hexagram: 'welling',
            chinesseSign: '頤',
            unicode: 'U+9814'
        },
        correcting: {
            name: 'correcting',
            upper: 'mountain',
            lower: 'wind',
            hexagram: 'correcting',
            chinesseSign: '大過',
            unicode: 'U+592A'
        },
        ascending: {
            name: 'ascending',
            upper: 'earth',
            lower: 'wind',
            hexagram: 'ascending',
            chinesseSign: '坎',
            unicode: 'U+574E'
        },
        arguing: {
            name: 'arguing',
            upper: 'earth',
            lower: 'water',
            hexagram: 'arguing',
            chinesseSign: '蠱',
            unicode: 'U+882B'
        },
        confining: {
            name: 'confining',
            upper: 'lake',
            lower: 'water',
            hexagram: 'confining',
            chinesseSign: '隨',
            unicode: 'U+96A7'
        },
        beforeCompletion: {
            name: 'beforeCompletion',
            upper: 'flame',
            lower: 'water',
            hexagram: 'beforeCompletion',
            chinesseSign: '升',
            unicode: 'U+5347'
        },
        deliverance: {
            name: 'deliverance',
            upper: 'thunder',
            lower: 'water',
            hexagram: 'deliverance',
            chinesseSign: '困',
            unicode: 'U+56F0'
        },
        dispersing: {
            name: 'dispersing',
            upper: 'wind',
            lower: 'water',
            hexagram: 'dispersing',
            chinesseSign: '解',
            unicode: 'U+89E3'
        },
        gorge: {
            name: 'gorge',
            upper: 'water',
            lower: 'water',
            hexagram: 'gorge',
            chinesseSign: '坎',
            unicode: 'U+574E'
        },
        enveloping: {
            name: 'enveloping',
            upper: 'mountain',
            lower: 'water',
            hexagram: 'enveloping',
            chinesseSign: '蒙',
            unicode: 'U+8499'
        },
        leading: {
            name: 'leading',
            upper: 'earth',
            lower: 'water',
            hexagram: 'leading',
            chinesseSign: '需',
            unicode: 'U+9706'
        },
        retiring: {
            name: 'retiring',
            upper: 'earth',
            lower: 'mountain',
            hexagram: 'retiring',
            chinesseSign: '既濟',
            unicode: 'U+65E2'
        },
        conjoining: {
            name: 'conjoining',
            upper: 'lake',
            lower: 'mountain',
            hexagram: 'conjoining',
            chinesseSign: '比',
            unicode: 'U+6BD4'
        },
        sojourning: {
            name: 'sojourning',
            upper: 'flame',
            lower: 'mountain',
            hexagram: 'sojourning',
            chinesseSign: '既濟',
            unicode: 'U+65E2'
        },
        smallExceeding: {
            name: 'smallExceeding',
            upper: 'thunder',
            lower: 'mountain',
            hexagram: 'smallExceeding',
            chinesseSign: '小過',
            unicode: 'U+5C0F'
        },
        infiltrating: {
            name: 'infiltrating',
            upper: 'wind',
            lower: 'mountain',
            hexagram: 'infiltrating',
            chinesseSign: '巽',
            unicode: 'U+5DFD'
        },
        limping: {
            name: 'limping',
            upper: 'water',
            lower: 'mountain',
            hexagram: 'limping',
            chinesseSign: '艮',
            unicode: 'U+826E'
        },
        bound: {
            name: 'bound',
            upper: 'mountain',
            lower: 'mountain',
            hexagram: 'bound',
            chinesseSign: '困',
            unicode: 'U+56F0'
        },
        humbling: {
            name: 'humbling',
            upper: 'earth',
            lower: 'mountain',
            hexagram: 'humbling',
            chinesseSign: '謙',
            unicode: 'U+8B19'
        },
        obstruction: {
            name: 'obstruction',
            upper: 'heaven',
            lower: 'earth',
            hexagram: 'obstruction',
            chinesseSign: '師',
            unicode: 'U+5E2B'
        },
        clustering: {
            name: 'clustering',
            upper: 'lake',
            lower: 'earth',
            hexagram: 'clustering',
            chinesseSign: '巽',
            unicode: 'U+5DFD'
        },
        prospering: {
            name: 'prospering',
            upper: 'flame',
            lower: 'earth',
            hexagram: 'prospering',
            chinesseSign: '晉',
            unicode: 'U+6649'
        },
        providingFor: {
            name: 'providingFor',
            upper: 'thunder',
            lower: 'earth',
            hexagram: 'providingFor',
            chinesseSign: '蒙',
            unicode: 'U+8499'
        },
        viewing: {
            name: 'viewing',
            upper: 'wind',
            lower: 'earth',
            hexagram: 'viewing',
            chinesseSign: '觀',
            unicode: 'U+89C0'
        },
        grouping: {
            name: 'grouping',
            upper: 'water',
            lower: 'earth',
            hexagram: 'grouping',
            chinesseSign: '泰',
            unicode: 'U+6CF0'
        },
        stripping: {
            name: 'stripping',
            upper: 'mountain',
            lower: 'earth',
            hexagram: 'stripping',
            chinesseSign: '咸',
            unicode: 'U+54B8'
        },
        field: {
            name: 'field',
            upper: 'earth',
            lower: 'earth',
            hexagram: 'field',
            chinesseSign: '坤',
            unicode: 'U+5764'
        }
    };
    
    
    